import React, { useMemo } from 'react'
import { string } from 'prop-types'
import styled from '@emotion/styled'
import { list } from '@groovehq/internal-design-system/lib/styles/elements'

import { styles } from './PasswordRequirements.styles'
import { passwordRequirements } from './PasswordRequirements.data'

const Requirement = styled.li`
  ${styles.item}
  opacity: ${props => (props.checked ? 0.25 : 1)};
`

const PasswordRequirements = ({ className, value }) => {
  const requirementList = useMemo(
    () => {
      return passwordRequirements.map(item => {
        const requirement = { ...item }
        requirement.validator(value)
        return requirement
      })
    },
    [value]
  )

  return (
    <ul className={className} css={[list.styles.preflight, styles.base]}>
      {requirementList.map(({ title, id, checked }) => (
        <Requirement key={id} checked={checked}>
          {title}
        </Requirement>
      ))}
    </ul>
  )
}

PasswordRequirements.propTypes = {
  className: string,
  value: string,
}

PasswordRequirements.defaultProps = {
  className: undefined,
  value: '',
}

export default PasswordRequirements
